module.exports = __webpack_public_path__ + "static/media/integration-deployemnt.54b6f4f4.jpg";